import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';
import i18n from 'src/i18n';
import { showErrorToast } from './toast';

const initialState = {
	list: [],
	total: 0,
	loading: false,
	draft: null,
};

const consultationsSlice = createSlice({
	name: 'consultations',
	initialState,
	reducers: {
		setConsultationsList(state, action) {
			state.list = action.payload.list;
			state.total = action.payload.count;
		},
		setConsultationsLoading(state, action) {
			state.loading = action.payload;
		},
		addConsultationItem(state, action) {
			state.list.push(action.payload);
		},
		updateConsultationItem(state, action) {
			const index = state.list.findIndex((item) => Number(item.id) === Number(action.payload.id));
			state.list.splice(index, 1, action.payload);
		},
		removeConultationItem(state, action) {
			state.list = state.list.filter((item) => item.id !== action.payload);
		},
		setConsultationDraft: (state, action) => {
			if (state.draft) {
				state.draft = { ...state.draft, ...action.payload };
			} else {
				state.draft = action.payload;
			}
		},
		
	},
});

export const {
	setConsultationsList,
	setConsultationsLoading,
	addConsultationItem,
	updateConsultationItem,
	removeConultationItem,
	setConsultationDraft
} = consultationsSlice.actions;

export const reloadConsultation = (id) => async (dispatch) => {
	dispatch(setConsultationsLoading(true));
	try {

		const response = await api.consultationById(id);
		dispatch(updateConsultationItem(response));

	} catch (error) {

		console.error(error);
		dispatch(
			showErrorToast({
				description: i18n.t('toasts.failedUpdateConsultation'),
			})
		);
		throw error;

	} finally {

		dispatch(setConsultationsLoading(false));

	}
};

export const getConsultationById = (id) => (dispatch, getState) => {
	return new Promise((resolve, reject) => {

		dispatch(setConsultationsLoading(true));
		
		const state = getState();
		const list = state.consultations.list;
		let item = list.find((item) => Number(item.id) === Number(id));

		if (item) {
			resolve(item);
		} else {

			api.consultationById(id)
				.then((res) => {
					resolve(res);
					dispatch(addConsultationItem(res));
				})
				.catch(() => {
					dispatch(
						showErrorToast({
							description: i18n.t('toasts.consultationNotFound', { id }),
						})
					);
					reject();
				}).finally(() => {
					dispatch(setConsultationsLoading(false));
				});
				
		}
	});
};


export const updateConsultation = ( consultation ) => async (dispatch) => {
	dispatch(setConsultationsLoading(true));
	try {
		
		const res = await api.editConsultation({ consultationId: consultation.id, payload: consultation });
		if (res) {
			dispatch(reloadConsultation(consultation.id));
		}

	} catch (error) {

		console.error(error);
		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateConsultation')
		}));

		throw error;

	} finally {
		dispatch(setConsultationsLoading(false));
	}

};

export const fetchConsultationList = (payload = {}) => async (dispatch) => {
	dispatch(setConsultationsLoading(true));
	try {

		// Используем publicationsList с типом consultations
		const res = await api.publicationsList({
			...payload,
			types: ['consultations']
		});
		dispatch(setConsultationsList(res));

	} catch (error) {

		console.error(error);
		dispatch(showErrorToast({
			description: i18n.t('toasts.failedGetPublications')
		}));

		throw error;
		
	} finally {

		dispatch(setConsultationsLoading(false));

	}
};

export default consultationsSlice.reducer;
